import React, { useContext, useEffect, useState } from 'react';
import './HeroSection.css';
import { LanguageContext } from '../context/LanguageContext';
import SearchBar from './SearchBar';

const HeroSection = () => {
  const {t} = useContext(LanguageContext);
  const [loadVideo, setLoadVideo] = useState(false);

  useEffect(()=>{
    setLoadVideo(true);
  },[])

  return (

    <div className="hero-section">
      {!loadVideo ? (
        <img
          
          className="video-poster"
          src="/images/nut-hostel-granada-background.png"
          alt="nut hostel fachada"

        />
        ) : (
          <video 
            className="hero-video"
            autoPlay
            muted 
            playsInline
            preload='none'
          >
            <source src="/videos/hero-video.mp4" type="video/mp4" />
            Tu navegador no soporta video HTML5.
          </video>
          
        )}
      

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">{t("hero", "title")}</h1>
          <h2 className="hero-subtitle">
            {t("hero", "subtitle")}
          </h2>
        </div>
          <SearchBar />
      </div>
      
    </div>
  );
};

export default HeroSection;